export default (node) => {
  /**
   * Data + elements
   */
  const buttons = node.querySelectorAll('[data-filter-btn]');
  const blocks = node.querySelectorAll('[data-inspiration-block]');

  /**
   * Init
   */
  const init = () => {
    if (!buttons.length || !blocks.length) return;

    // Handle filter button clicks
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.filter.toLowerCase().trim();

        // Update active button styling
        buttons.forEach((btn) => btn.classList.remove('active'));
        button.classList.add('active');

        // Show/hide blocks based on tag match
        blocks.forEach((block) => {
          const tags =
            block.dataset.tags
              ?.toLowerCase()
              .split(',')
              .map((tag) => tag.trim()) || [];

          if (filter === 'all' || tags.includes(filter)) {
            block.style.display = 'block';
          } else {
            block.style.display = 'none';
          }
        });
      });
    });
  };

  init();
};
